<!-- Title -->
<div class="d-flex justify-content-between align-items-center mb-2">
  <h3
    class="text-main font-weight--400 my-3"
  >
    Filteren ({{ (appStateStore.organizationList$ | async)?.length ?? 0 }} organisaties gevonden)
  </h3>
  <button mat-icon-button (click)="sheet.dismiss('closed-by-user')">
    <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
  </button>
</div>
<!-- End title -->
<!-- Filters -->
<div class="d-flex flex-column gap-2 w-100">
  <div class="d-flex gap-2 align-items-center">
    <!-- Search -->
    <mat-form-field appearance="outline" class="w-100 no-subscript search-form-field">
      <mat-label>Zoek organisaties</mat-label>
      <input [formControl]="searchQueryInput" matInput placeholder="Zoek organisaties" value="">
    </mat-form-field>
    <!-- Invisible icon to just fill the space -->
    <mat-icon
      fontSet="material-symbols-outlined"
      style="opacity: 0"
      class="align-self-center"
    >
      information
    </mat-icon>
  </div>
  <!-- Goal more information -->

  <!-- Goal -->
  <div class="d-flex gap-2 align-items-center">
    <mat-form-field appearance="outline" class="no-subscript w-100">
      <mat-label>Alle doelen</mat-label>
      <mat-select [compareWith]="compareById" [formControl]="goalSelect" multiple
                  panelClass="goal-select-panel">
        @for (goal of goalList; track goal.id) {
          <mat-option [value]="goal"
                      [style.--goal-color]="goalColor(goal).color"
                      [style.--goal-background]="goalColor(goal).background">{{ goal.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Goal more information -->
    <mat-icon
      fontSet="material-symbols-outlined"
      [matMenuTriggerFor]="goalsPopover"
      class="cursor--pointer align-self-center"
    >
      information
    </mat-icon>

    <!-- Goal more information panel -->
    <mat-menu #goalsPopover="matMenu">
      <ng-template matMenuContent>
        <div class="px-3 py-1">
          <h3 class="m-0 p-0">Doel</h3>
          <p
            class="my-2 font-weight--400"
          >
            Waarom zijn de makers en deelnemers betrokken?
          </p>
          <a
            href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
            target="_blank"
            rel="noopener noreferrer"
            class="d-flex align-items-center cta-link"
          >
            <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
            informatie
          </a>
        </div>
      </ng-template>
    </mat-menu>
  </div>

  <!-- Reach -->
  <div class="d-flex gap-2 align-items-center">
    <mat-form-field appearance="outline" class="no-subscript w-100">
      <mat-label>Alle reikwijdten</mat-label>
      <mat-select [compareWith]="compareById" [formControl]="reachSelect" multiple>
        @for (reach of reachList; track reach.id) {
          <mat-option [value]="reach">{{ reach.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Reach more information -->
    <mat-icon
      fontSet="material-symbols-outlined"
      [matMenuTriggerFor]="reachPopover"
      class="cursor--pointer align-self-center"
    >
      information
    </mat-icon>

    <!-- Reach more information panel -->
    <mat-menu #reachPopover="matMenu">
      <ng-template matMenuContent>
        <div class="px-3 py-1">
          <h3 class="m-0 p-0">Reikwijdte</h3>
          <p
            class="my-2 font-weight--400"
          >
            Bereikt het initiatief mensen op lokaal- of provinciaal niveau of landelijk?
          </p>
          <a
            href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
            target="_blank"
            rel="noopener noreferrer"
            class="d-flex align-items-center cta-link"
          >
            <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
            informatie
          </a>
        </div>
      </ng-template>
    </mat-menu>
  </div>

  <!-- Province -->
  <div class="d-flex gap-2 align-items-center">
    <mat-form-field appearance="outline" class="w-100 no-subscript">
      <mat-label>Alle provincies</mat-label>
      <mat-select [compareWith]="compareById" [formControl]="provinceSelect" multiple>
        @for (province of provinceList; track province.id) {
          <mat-option [value]="province">{{ province.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <!-- Invisible icon to just fill the space -->
    <mat-icon
      fontSet="material-symbols-outlined"
      style="opacity: 0"
      class="align-self-center"
    >
      information
    </mat-icon>
  </div>

  <!-- Heritage type -->
  <div class="d-flex gap-2 align-items-center">
    <mat-form-field appearance="outline" class="no-subscript w-100">
      <mat-label>Alle erfgoedtypes</mat-label>
      <mat-select [compareWith]="compareById" [formControl]="heritageTypeSelect" multiple>
        @for (heritageType of heritageTypeList; track heritageType.id) {
          <mat-option [value]="heritageType">{{ heritageType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Heritage type more information -->
    <mat-icon
      fontSet="material-symbols-outlined"
      [matMenuTriggerFor]="heritageTypePopover"
      class="cursor--pointer align-self-center"
    >
      information
    </mat-icon>

    <!-- Heritage type more information panel -->
    <mat-menu #heritageTypePopover="matMenu">
      <ng-template matMenuContent>
        <div class="px-3 py-1">
          <h3 class="m-0 p-0">Type erfgoed</h3>
          <p
            class="my-2 font-weight--400"
          >
            Welke termen omschrijven de activiteiten van deze groep het best?
          </p>
          <a
            href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
            target="_blank"
            rel="noopener noreferrer"
            class="d-flex align-items-center cta-link"
          >
            <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
            informatie
          </a>
        </div>
      </ng-template>
    </mat-menu>
  </div>

  <!-- Impact type -->
  <div class="d-flex gap-2 align-items-center">
    <mat-form-field appearance="outline" class="no-subscript w-100">
      <mat-label>Alle impacttypes</mat-label>
      <mat-select [compareWith]="compareById" [formControl]="impactTypeSelect" multiple>
        @for (impactType of impactTypeList; track impactType.id) {
          <mat-option [value]="impactType">{{ impactType.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <!-- Impact type more information -->
    <mat-icon
      fontSet="material-symbols-outlined"
      [matMenuTriggerFor]="impactTypePopover"
      class="cursor--pointer align-self-center"
    >
      information
    </mat-icon>

    <!-- Impact type more information panel -->
    <mat-menu #impactTypePopover="matMenu">
      <ng-template matMenuContent>
        <div class="px-3 py-1">
          <h3 class="m-0 p-0">Impacttype</h3>
          <p
            class="my-2 font-weight--400"
          >
            Welke impact of waarde heeft deze groep op/voor de leefomgeving, cultuur en/of natuur?
          </p>
          <a
            href="https://netwerklevenderfgoed.nl/classificatie-erfgoedinitiatieven"
            target="_blank"
            rel="noopener noreferrer"
            class="d-flex align-items-center cta-link"
          >
            <mat-icon fontSet="material-symbols-outlined" class="icon-as-text">open_in_new</mat-icon>&nbsp;Meer
            informatie
          </a>
        </div>
      </ng-template>
    </mat-menu>
  </div>

  <!-- Reset -->
  <div class="d-flex align-items-center">
    <button class="w-100" mat-stroked-button (click)="clearFilters()">Wis filters</button>
  </div>
</div>
<!-- End filters -->
